export enum RULE_MESSAGE_TYPE {
	Info = 'Info',
	Warning = 'Warning',
	Error = 'Error'
}

export enum RULE_STATUS {
	NOT_REVIEWED = 0,
	FLAG = 1,
	PASSED = 2,
	FAILED = 3
}

export enum VIEW_COMMENTS_MODE {
	COMMENTS = 'comment',
	STIPS = 'stips'
}

export enum ORDER_STATE {
	APPROVED = 'Approved',
	REJECTED = 'Rejected',
	INQUALITY = 'UnderReview',
	CANCELLED = 'Cancelled',
	POST_REVISION_RECEIVED = 'PostRevisionReceived'
}

export enum RULES_INDICATOR {
	COMPLETE = 'Completed',
	NODEFFERED = 'NoDeffered',
	INPROCESS = 'Inprocess'
}

export const isFORMSet = (form: string): boolean => {
	return /FORMSET-CV/.test(form);
}

export const RULE_UPDATED_EVENT = 'Rule Updated Event';

export enum RULESET_NAMES {
  POST_REVISION = 'POST_REVISION'
}
